import { render } from "./ContactUsView.vue?vue&type=template&id=70eb7c9a&ts=true"
import script from "./ContactUsView.vue?vue&type=script&lang=ts"
export * from "./ContactUsView.vue?vue&type=script&lang=ts"

import "./ContactUsView.vue?vue&type=style&index=0&id=70eb7c9a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__